import qs from 'qs';
import axios from 'axios';
import { SlideDataServices } from '@src/slide/domain/slide-app/core/slide-data-services.core';
import { getXSRF } from '@src/slide/domain/slide-app/utils/cookie-utils';

type CreateQRCodeFn = (url: string) => Promise<string>;

export const createWxQRCode: CreateQRCodeFn = url => new Promise((resolve, reject) => {
    if (!url) {
        reject();
    }
    const { domainId = '', padId = '' } = SlideDataServices.DocInfoManager() ?? {};
    axios.get(`/cgi-bin/online_docs/wxqrcode?${qs.stringify({
        dataType: 0,
        domainId,
        padId,
        page: 'pages/detail/detail',
        ac: 'mini_app_share',
        param: JSON.stringify({ url }),
        width: 200,
        xsrf: getXSRF(),
    })}`, {
        responseType: 'blob',
    }).then((response) => {
        if (response.status === 200) {
            resolve(URL.createObjectURL(response.data));
        }
        reject();
    })
        .catch(reject);
});

export const createQqQRCode: CreateQRCodeFn = url => new Promise((resolve, reject) => {
    if (!url) {
        reject();
    }
    const { domainId = '', padId = '' } = SlideDataServices.DocInfoManager() ?? {};
    axios.get(`/api/share/gen_qrcode?${qs.stringify({
        domainId,
        padId,
        codeType: 8,
        platform: 2,
        page: 'pages/detail/detail',
        param: JSON.stringify({ url }),
        ac: 'share',
        width: 200,
        xsrf: getXSRF(),
    })}`).then((response) => {
        if (response.status === 200 && response.data.retcode === 0) {
            resolve(`data:image/png;base64,${response.data.result.image}`);
        }
        reject();
    })
        .catch(reject);
});

class QRCodeManager {
    private cachedUrl: string | null = null;
    private cachedQRCode: string | null = null;
    private createQRCodeFn: CreateQRCodeFn;

    public constructor(createQRCodeFn: CreateQRCodeFn) {
        this.createQRCodeFn = createQRCodeFn;
    }

    public clearCache() {
        this.cachedUrl = null;
        this.cachedQRCode = null;
    }

    public async createQRCode(url: string) {
        if (this.cachedUrl === url) {
            return this.cachedQRCode as string;
        }
        try {
            const qrCode = await this.createQRCodeFn(url);
            this.cachedUrl = url;
            this.cachedQRCode = qrCode;
            return qrCode;
        } catch (error) {
            this.clearCache();
            throw error;
        }
    }
}

const wxQRCodeManager = new QRCodeManager(createWxQRCode);
const qqQRCodeManager = new QRCodeManager(createQqQRCode);

export { wxQRCodeManager, qqQRCodeManager };
